import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=40ab164b&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/3aece8dd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40ab164b', component.options)
    } else {
      api.reload('40ab164b', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=40ab164b&", function () {
      api.rerender('40ab164b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer.vue"
export default component.exports